import React, { useEffect, useState } from 'react';
import RemovePluginConfirmationModal from '../../../../../../Modals/MissionControl/ClientManifest/RemovePluginConfirmationModal';
import ClientPluginNotesModal from '../../../../../../Modals/MissionControl/ClientManifest/ClientPluginNotesModal';
import EditPluginModal from '../../../../../../Modals/MissionControl/ClientManifest/EditPluginModal';
import ClientPluginsHeader from './ClientPluginsHeader';
import ClientPluginsBody from './ClientPluginsBody';

const ClientPluginList = ({
    instanceId,
    plugins,
    canEditPlugins,
    pluginStatuses,
    refreshManifest,
}) => {
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [notesModalOpen, setNotesModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [pluginToRemove, setPluginToRemove] = useState({ name: '', uid: '' });
    const [pluginNoteText, setPluginNoteText] = useState('');
    const [pluginToEdit, setPluginToEdit] = useState();
    const [pluginsList, setPluginsList] = useState([]);

    useEffect(() => {
        //sort inherited first then alphabetical by name
        let sortedList = [...plugins].sort(
            (a, b) =>
                b.isInherited - a.isInherited || a.name.localeCompare(b.name)
        );
        setPluginsList(sortedList);
    }, [plugins]);

    const handleRemovePluginClick = (plugin) => {
        setPluginToRemove(plugin);
        setConfirmModalOpen(true);
    };

    const handlePluginNotesClick = (pluginNoteText) => {
        setPluginNoteText(pluginNoteText);
        setNotesModalOpen(true);
    };

    const handlePluginEditClick = (plugin) => {
        setPluginToEdit(plugin);
        setEditModalOpen(true);
    };

    return (
        <>
            <RemovePluginConfirmationModal
                pluginRemovalCandidate={pluginToRemove}
                isOpen={confirmModalOpen}
                closeModal={() => setConfirmModalOpen(false)}
                refreshManifest={() => refreshManifest()}
            />
            <ClientPluginNotesModal
                isOpen={notesModalOpen}
                noteText={pluginNoteText}
                closeModal={() => setNotesModalOpen(false)}
            />
            <EditPluginModal
                key={pluginToEdit?.uid}
                isOpen={editModalOpen}
                closeModal={() => setEditModalOpen(false)}
                plugin={pluginToEdit}
                refreshManifest={() => refreshManifest()}
            />
            <table className="table table-striped table-head-fixed plugins text-light">
                <ClientPluginsHeader />

                <ClientPluginsBody
                    instanceId={instanceId}
                    plugins={pluginsList}
                    handlePluginEdit={handlePluginEditClick}
                    handlepluginNotes={handlePluginNotesClick}
                    handleRemovePlugin={handleRemovePluginClick}
                    canEditPlugins={canEditPlugins}
                    statuses={pluginStatuses}
                />
            </table>
        </>
    );
};

export default React.memo(ClientPluginList);
